"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMetrics = void 0;
const react_1 = require("react");
const mutation_1 = __importDefault(require("swr/mutation"));
const utils_1 = require("../utils");
const constants_1 = require("../constants");
const useMetrics = (props) => {
    const newBucket = () => ({
        start: new Date().toISOString(),
        stop: null,
        toggles: {},
    });
    const [metrics] = (0, react_1.useState)({
        bucket: newBucket(),
    });
    const { trigger: sendMetrics } = (0, mutation_1.default)([`${props.url}/client/metrics`, props.token, "POST"], (utils_1.fetcher));
    const initAndCountFlagRender = (flag, variant) => {
        if (notYetCountingThisFlag(flag))
            startNewFlagRenderCounter(flag);
        countOneFlagRender(flag);
        if (notEmptyVariant(variant))
            initAndCountVariantRender(flag, variant);
    };
    const initAndCountVariantRender = (flag, variant) => {
        if (notYetCountingThisVariant(flag, variant)) {
            startNewVariantRenderCounter(flag, variant);
        }
        countOneVariantRender(flag, variant);
    };
    const notYetCountingThisFlag = (flag) => !metrics.bucket.toggles?.[flag.name];
    const notYetCountingThisVariant = (flag, variant) => !metrics.bucket.toggles?.[flag.name].variants[variant];
    const countOneFlagRender = (flag) => metrics.bucket.toggles[flag.name][flag.enabled ? "yes" : "no"]++;
    const countOneVariantRender = (flag, variant) => metrics.bucket.toggles[flag.name].variants[variant]++;
    const metricsBucketNotEmpty = () => !!Object.keys(metrics.bucket.toggles).length;
    const buildMetricsPayload = () => ({
        appName: props.appName,
        instanceId: "browser",
        bucket: { ...metrics.bucket, stop: new Date().toISOString() },
    });
    const notEmptyVariant = (variant) => !!variant && variant !== constants_1.EMPTY_VARIANT.name;
    const startNewMetricsBucket = () => {
        metrics.bucket = newBucket();
    };
    const newFlagRenderCounter = () => ({
        yes: 0,
        no: 0,
        variants: {},
    });
    const startNewFlagRenderCounter = (flag) => {
        metrics.bucket.toggles[flag.name] = newFlagRenderCounter();
    };
    const startNewVariantRenderCounter = (flag, variant) => {
        metrics.bucket.toggles[flag.name].variants[variant] = 0;
    };
    const checkMetricsBucketAndSendCurrentMetrics = () => {
        if (metricsBucketNotEmpty()) {
            sendMetrics(buildMetricsPayload());
            startNewMetricsBucket();
        }
    };
    (0, react_1.useEffect)(() => {
        setTimeout(checkMetricsBucketAndSendCurrentMetrics, 2000);
        const interval = setInterval(checkMetricsBucketAndSendCurrentMetrics, 30000);
        return () => clearInterval(interval);
    }, []);
    const onFlagRender = (flag, variant) => {
        initAndCountFlagRender(flag, variant);
    };
    return onFlagRender;
};
exports.useMetrics = useMetrics;
//# sourceMappingURL=use-metrics.hook.js.map